import gsap from 'gsap'

export function runBackgroundAnimation (onComplete = () => {}) {
  const blueDot = document.querySelector('.blue-glow')
  const whiteLight = document.querySelector('.light-gradient')

  gsap.to(blueDot, {
    scale: 1.2,
    opacity: 0.3,
    duration: 3,
    repeat: -1,
    yoyo: true,
    ease: 'power1.inOut'
  })

  gsap.to(whiteLight, {
    scaleY: 1.5,
    duration: 3,
    repeat: -1,
    yoyo: true,
    ease: 'power1.inOut'
  })
}
